import 'lazysizes/plugins/bgset/ls.bgset.min.js';
import 'lazysizes/plugins/respimg/ls.respimg.min.js';
import 'lazysizes/lazysizes.min.js';